import { formatPlainText } from './formatters.js';
import { buildProseGroupRuns } from './buildCueContent.js';

/**
 * @param {object} eventGroup
 * @param {import('./options.js').TranscriptExportOptions} options
 * @param {{ frameRate: number|string, dropFrame: boolean }} project
 * @param {import('./formatters.js').TranscriptLabelSet} labels
 * @returns {import('./buildCued.js').TranscriptBlock[]}
 */
export function buildProseBlocks(eventGroup, options, project, labels) {
    const events = (eventGroup.events || [])
        .filter((event) => formatPlainText(event.text))
        .sort((a, b) => a.start - b.start);

    /** @type {object[][]} */
    const groupsByTc = [];
    /** @type {object[]} */
    let groupByTc = [];

    events.forEach((event, eventIndex, list) => {
        if (eventIndex > 0 && (!options.autoGroupByTc || event.start - list[eventIndex - 1].end > options.duration)) {
            groupsByTc.push(groupByTc);
            groupByTc = [event];
        } else {
            groupByTc.push(event);
        }
    });

    if (groupByTc.length > 0) {
        groupsByTc.push(groupByTc);
    }

    return groupsByTc.map((tcGroup, groupIndex) => ({
        kind: 'prose',
        runs: buildProseGroupRuns({
            events: tcGroup,
            index: groupIndex + 1,
            options,
            project,
            labels,
        }),
    }));
}
